import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const useGetVendorData = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const handleSaveHistory = async () => {
      try {
        axios
          .post(
            "https://aipricingtool-python.onrender.com/get_pdf_names_by_user",
            { user_identifier: id }
          )
          .then((response) => {
            setHistory(response.data);
            console.log(response.data);
          })
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    handleSaveHistory();

    return () => {};
  }, []);

  return { history, loading, error };
};

export default useGetVendorData;
